module.exports = __webpack_public_path__ + "db679e8b6d4fceab2930e8ee743d4a3e.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/pt.json
// module id = 1157
// module chunks = 0